import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './containers/main/main.component';
import { ApiService } from './services/api.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared';
import { StoreModule } from '@ngrx/store';
import { reducers, IntegrationsEffects } from './store';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IntegrationsComponent } from './containers/integrations/integrations.component';

@NgModule({
  declarations: [MainComponent, IntegrationsComponent],
  providers: [ApiService],
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    RouterModule,
    NgbModule,
    StoreModule.forFeature('Integrations', reducers),
    EffectsModule.forFeature([IntegrationsEffects]),
    ReactiveFormsModule,
  ],
})
export class IntegrationsModule {}
